import { Breakpoints } from '@/hooks/useBreakpoint';
import styled, { css } from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex: 1;
  justify-content: center;
`;

export const Conteudo = styled.div<{
  $breakpoint: Breakpoints;
  $caminhoURL: string;
}>`
  display: flex;
  flex: 1;
  max-width: 1280px;
  flex-direction: row;
  justify-content: space-between;

  ${({ $breakpoint, theme }) => {
    if ($breakpoint === 'mobile') return '';
    return css`
      padding: 0 ${theme.spacing[6]}px;
    `;
  }}

  ${({ theme, $caminhoURL, $breakpoint }) => {
    if (
      ['/cadastrar', '/esqueci-minha-senha', '/redefinir-senha'].includes(
        $caminhoURL,
      ) &&
      $breakpoint === 'desktop'
    )
      return css`
        max-width: 700px;
        padding: 0 ${theme.spacing[4]}px;
      `;
  }}
`;

export const ImageContainer = styled.div`
  display: flex;
  position: relative;

  height: 27px;
  width: auto;

  margin-right: ${({ theme }) => theme.spacing[4]}px;
`;
